export default {
    currEnv: 'qa',
    companyNameRegex: /^[ÑñA-Za-z0-9&",.! \'-]{2,100}$/,
    fullNameRegex: /^([ÑñA-Za-z- \.']{1,100})$/,
    contactNoRegex: /^[+]639[0-9]{9}$/,
    emailRegex: /^[\w.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    messageRegex: /^[ÑñA-Za-z0-9\\s&\'"\-,.\/():;?!*\[\] ]{1,200}$/
}